import { render, staticRenderFns } from "./DocumentPOSAgain.vue?vue&type=template&id=762198b3"
import script from "./DocumentPOSAgain.vue?vue&type=script&lang=js"
export * from "./DocumentPOSAgain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports